import { RescueEventType } from './rescue.event.type';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { InvestmentsService } from '../investments.service';
import { EventTypes } from '../../../shared/EventTypes';
import { FormGroup } from '@angular/forms';
import { Rescue } from '../models/rescue';
import { TweenMax, Quint } from 'gsap';

@Component({
	selector: 'app-rescue',
	templateUrl: './rescue.component.html',
	styleUrls: ['./rescue.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class RescueComponent implements OnInit, OnDestroy {
	title = 'Resgate de Investimento';
	activeBackButton: boolean;

	hasSubmited: boolean;
	showStepButtons: boolean = true;

	investmentId: number;
	form: FormGroup;

	rescueData: Rescue = new Rescue();

	constructor(private route: ActivatedRoute, private investmentService: InvestmentsService) { }

	ngOnInit() {
		this.route.params.subscribe(data => {
			this.investmentId = data.id;
		});
		/**
		 * Faz a troca de botões ao chegar no final dos passos.
		 */
		AppEventDispatcher.listen(RescueEventType.BUTTONS, data => {

			TweenMax.to('.buttons', .8, {bottom: '-100%', ease: Quint.easeOut});
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
				});
			});

		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(RescueEventType.BUTTONS);
	}

	onSetTitleSubtitle(data) {
		this.title = data.title;
	}

	onSetForm(form: FormGroup) {
		this.form = form;
	}

	sendForm(event) {
		if (this.form.valid) {
			AppEventDispatcher.dispatch(RescueEventType.SEND.RESCUE_SEND_RESULT, null);
		}
	}

	onShowStepButtons(value: boolean){
		this.showStepButtons = value;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/rescue/rescue.component.ts